import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

type Trigger = ({ onClick }: { onClick(result: any): void }) => JSX.Element;

interface ModalBasicProps {
  children: ({ onClose }: { onClose(result: any): void }) => JSX.Element;
  notification?: ({ result }: { result: any }) => JSX.Element | string;
  onClose?(result: any): void;
}
interface ModalWithTrigger extends ModalBasicProps {
  open?: boolean;
  trigger: Trigger;
}

interface ModalWithOpen extends ModalBasicProps {
  open: boolean;
  trigger?: Trigger;
}

type ModalProps = ModalWithOpen | ModalWithTrigger;

function Modal({
  children,
  notification,
  onClose,
  open,
  trigger,
}: ModalProps): JSX.Element {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [openNotification, setOpenNotification] = useState<boolean>(false);
  const [result, setResult] = useState<any>(null);

  return (
    <>
      {trigger ? trigger({ onClick: () => setIsDrawerOpen(true) }) : undefined}
      <Drawer
        anchor="right"
        data-testid="modal"
        onClose={() => {
          setIsDrawerOpen(false);
          onClose?.(result);
        }}
        open={isDrawerOpen || open}
      >
        {children({
          onClose: (result) => {
            setResult(result);
            if (result && notification) setOpenNotification(true);
            setIsDrawerOpen(false);
            onClose?.(result);
          },
        })}
      </Drawer>
      {notification && (
        <Snackbar
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          autoHideDuration={6000}
          onClose={() => setOpenNotification(false)}
          open={openNotification}
        >
          <Alert
            onClose={() => setOpenNotification(false)}
            severity="success"
            sx={{ width: '100%' }}
          >
            {notification({ result })}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default Modal;
